module.exports = "/_next/static/images/generic-6e327c1bbba5593bc7e4de8a0e2d43e8.svg";